export const ACCEPTED_FILE_TYPES =
  'image/png, image/jpeg, image/jpg, application/pdf, text/plain, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, .eml, .msg, message/rfc822, application/vnd.ms-outlook';
export const STOP_COMPLETION_FILE_TYPES =
  'image/png, image/jpeg, image/jpg, application/pdf, .msg, message/rfc822, application/vnd.ms-outlook';
export const BILLING_FILE_TYPES = {
  w9: 'image/png, image/jpeg, image/jpg, application/pdf',
  voided_check: 'image/png, image/jpeg, image/jpg, application/pdf',
  notice_of_assignment: 'image/png, image/jpeg, image/jpg, application/pdf',
};
export const USER_PICTURE_FILE_TYPES =
  'image/png, image/jpeg, image/tiff, image/heif';

export const CSV_FILE_TYPES =
  '.csv, text/csv, application/csv, text/x-csv, application/x-csv';
